import type React from 'react';
import { cls } from '@/lib/utils';

interface PageProperties extends React.ComponentPropsWithoutRef<'div'> {
  children: React.ReactNode;
}

export default function Main({ children, ...properties }: PageProperties) {
  return (
    <main
      className={cls`
        grid
        grid-cols-body
        relative
      `}
    >
      <div className={cls`grid col-start-2 gap-10`} {...properties}>
        {children}
      </div>
    </main>
  );
}
